import DOMPurify from 'dompurify';

/**
 * Sanitize HTML content to prevent XSS attacks.
 * Whitelists safe tags for blog content while stripping all scripts and event handlers.
 */
export const sanitizeHTML = (html) => {
    if (!html) return '';

    return DOMPurify.sanitize(html, {
        ALLOWED_TAGS: [
            // Headings
            'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
            // Text formatting
            'p', 'br', 'strong', 'b', 'em', 'i', 'u', 's', 'del', 'ins', 'mark', 'sub', 'sup',
            'span', 'small', 'abbr', 'cite', 'q',
            // Lists
            'ul', 'ol', 'li',
            // Links
            'a',
            // Media
            'img', 'figure', 'figcaption', 'video', 'source', 'iframe',
            // Code
            'pre', 'code', 'kbd', 'samp', 'var',
            // Tables
            'table', 'thead', 'tbody', 'tfoot', 'tr', 'th', 'td', 'caption', 'colgroup', 'col',
            // Block elements
            'div', 'section', 'article', 'aside', 'header', 'footer', 'nav', 'main',
            'blockquote', 'hr', 'details', 'summary',
            // Task lists (TipTap)
            'input', 'label',
        ],
        ALLOWED_ATTR: [
            'href', 'target', 'rel', 'src', 'alt', 'title', 'width', 'height',
            'class', 'id', 'style', 'data-*',
            'colspan', 'rowspan', 'scope', 'start', 'type', 'reversed',
            'loading', 'decoding',
            // For task lists
            'checked', 'disabled', 'data-type', 'data-checked',
        ],
        ALLOW_DATA_ATTR: true,
        ADD_ATTR: ['target'],
        FORBID_TAGS: ['script', 'style', 'textarea', 'form', 'button', 'select', 'option'],
        FORBID_ATTR: ['onerror', 'onclick', 'onload', 'onmouseover', 'onfocus', 'onblur', 'onsubmit', 'onchange'],
    });
};

export default sanitizeHTML;
